module.exports = __webpack_public_path__ + "static/retail-9b6a8125fb663b11d1b5dc35e82e55d9.jpg";